import React                              from 'react';
import classnames                         from 'classnames';
import { materialType as defaultOptions } from 'pu-data/SelectOptions';
import { materialType as tooltip }        from 'pu-data/Tooltips';
import SelectComponent                    from './SelectComponent';

const MaterialType = (props) => {
  const name = 'material_type';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={name}
      onChange={props.onChange || onChange}
      options={props.options}
      tooltip={tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName}
      className={classnames('material-type', props.className)} />
  );
};

MaterialType.defaultProps = {
  options : defaultOptions,
  label   : 'Material<br class="d-none d-lg-block d-xl-none" /> Type',
  required: true,
};

export default MaterialType;
